export default __webpack_public_path__ + "static/media/course-thumbnail.81bc8101.png";